import React from "react";
import styled from "styled-components";
import Loc from '../../images/sijainti.svg';
import Phone from '../../images/puhelin.svg';
import Mail from '../../images/kirjekuori.svg';
import Instagram from "../../images/ICON_IG2026.svg"
import Facebook from "../../images/ICON_FB2026.svg"


import Map from "../map"

const FooterContainer = styled.div`
  display: flex;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`
const ContactContainer = styled.div`
  width: 40%;

  @media (max-width: 768px) {
    width: 100%;
  }
`
const MapContainer = styled.div`
  width: 60%;
  position: relative;
  height: 200px;

  @media (max-width: 768px) {
    width: 100%;
  }
`

const SocialLinks = styled.div`
  display: flex;
  gap: 14px;
  margin-top: 1.5rem;
  margin-left: 40%;
  margin-right: 40%;
`

const SocialLink = styled.a`
  display: inline-flex;
  width: 28px;
  height: 28px;
  opacity: 0.95;

  svg {
    width: 100%;
    height: 100%;
  }

  &:hover {
    opacity: 1;
  }
`

const ParkingSection = styled.div`
  text-align: center;
  color: white;
  margin-top: 1.5rem;
`

const ParkingTitle = styled.h3`
  font-weight: 400;
  margin-bottom: 1rem;
`

const ParkingText = styled.p`
  margin: 0;
  line-height: 1.5;
`

const Contact = () => (
  <div
    id="contact"
    style={{
      background: `#263f35ff`,
    }}
  >
    <div
      className="contact"
      style={{
        margin: `0 auto`,
        maxWidth: 960,
        padding: `1.0875rem 1.45rem`,
        paddingBottom: `5rem`,
        paddingTop: `3rem`,
      }}
    >
      <div
        style={{
          display: `inline-block`,
          padding: `0 1.0875rem 1.45rem`,
          width: `100%`,
        }}
      >
        <h1
          style={{
            textAlign: `center`,
            marginTop: `1.45rem`,
            marginBottom: `3rem`,
            color: `white`,
          }}
        >
          Yhteystiedot
        </h1>

        <FooterContainer>
          <ContactContainer style={{
            paddingBottom: "30px"
            }}>
            <div style={{
              display: "flex",
            }}
              >
              <div style={{
                margin: `auto 30px`,
                width: `10px`
              }}>
                <Loc
                  style={{
                    width: `200%`,
                    height: `2000%`,
                  }}
                />
              </div>
              <div>
              <p> Hiusstudio Gaia</p>
          
              <p> Martinlaaksonkuja 1</p>
              <p> 01620 Vantaa</p>
              </div>
            </div>
            <br/>
            <div style={{
              display: "flex",
            }}
              >
              <div style={{
                margin: `auto 30px`,
                width: `10px`
              }}>
                <Phone
                  style={{
                    width: `200%`,
                    height: `2000%`,
                    paddingBottom: `3px`
                  }}
                />
              </div>
              <div>
                <p>045 279 0199 </p>
              </div>
            </div>

            <br/>

            <div style={{
              display: "flex",
            }}
              >
              <div style={{
                margin: `auto 30px`,
                width: `10px`
              }}>
                <Mail
                  style={{
                    width: `200%`,
                    height: `2000%`,
                    paddingBottom: `2px`
                  }}
                />
              </div>
              <div>
                <p>hiusstudio.gaia@gmail.com</p>
              </div>
            </div>

            <SocialLinks>
              <SocialLink
                href="https://www.facebook.com/hiusstudiogaia"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Hiusstudio Gaia Facebook"
              >
                <Facebook />
              </SocialLink>
              <SocialLink
                href="https://www.instagram.com/hiusstudiogaia"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Hiusstudio Gaia Instagram"
              >
                <Instagram />
              </SocialLink>
            </SocialLinks>

          </ContactContainer>

          <MapContainer>
            <Map />
          </MapContainer>
        </FooterContainer>

        <ParkingSection>
          <ParkingTitle>Parkkipaikkoja:</ParkingTitle>
          <ParkingText>
            Ei Kiekkoa - Kulttuuritalo Martinus
            <br />
            4h - Laajametsänkuja
            <br />
            2h - Martinlaakson uimahalli
            <br />
            2h - Martinlaakson ostoskeskus
            <br />
            60min - Liikkeen edessä, tiensivussa
          </ParkingText>
        </ParkingSection>
      </div>
    </div>
  </div>
)

export default Contact
